import React from 'react';

// Muestra solo una imagen a pantalla completa
export default function ImageOnly({ rotation = 'left' }) {
  const angle = rotation === 'right' ? '90deg' : '-90deg';

  // Truco para cubrir sin bordes: rotamos un contenedor que tiene
  // width/height invertidos (vw/vh) y adentro el <img> hace cover.
  const rotated = rotation === 'left' || rotation === 'right';

  const outerStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    overflow: 'hidden',
    backgroundColor: '#000',
  };

  const innerStyle = rotated
    ? {
        position: 'absolute',
        top: '50%',
        left: '50%',
        // swap dimensiones para que al rotar ocupe todo
        width: '100vh',
        height: '100vw',
        transform: `translate(-50%, -50%) rotate(${angle})`,
        transformOrigin: 'center center',
      }
    : {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
      };

  const imgStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  };

  return (
    <div style={outerStyle}>
      <div style={innerStyle}>
        <img src="/messi.jpeg" alt="Imagen" style={imgStyle} />
      </div>
    </div>
  );
}

